import { FIDE, withReplayLimits } from './fide.js';
import type { RuleSet, VariantId } from './types.js';

export const VARIANTS: Readonly<Record<VariantId, RuleSet>> = {
  fide: FIDE,
};

const VARIANT_IDS = Object.keys(VARIANTS) as readonly VariantId[];

export const DEFAULT_VARIANT: VariantId = 'fide';

export function isVariantId(value: unknown): value is VariantId {
  return typeof value === 'string' && (VARIANT_IDS as readonly string[]).includes(value);
}

export function getRuleSet(id: VariantId): RuleSet {
  return VARIANTS[id];
}

export { FIDE, withReplayLimits };
export type { RuleSet, VariantId };
